<template>
  <v-main>
    <v-container fluid>
      <br />
      <v-row justify="start">
        <v-col style="min-width: 175px">
          <span
            class="text-h5 font-weight-bold"
            v-text="`ET EPAPERS (${count})`"
          ></span>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="3">
          <v-text-field
            v-model="search_keyword"
            label="Search ... "
            prepend-inner-icon="mdi-newspaper-variant-multiple-outline"
            @keydown.enter="getData"
            @change="page = 1"
          ></v-text-field>
        </v-col>
        <v-col sm="3">
          <v-autocomplete
            ref="word_count"
            v-model="word_count"
            :items="wordCounts"
            label="Select word count"
            prepend-icon="mdi-domain"
            @change="getData"
          ></v-autocomplete>
        </v-col>
        <v-col sm="3">
          <v-menu
            v-model="date_menu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="date_filter"
                label="Date Search"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="date_filter"
              @input="getData"
              @change="date_menu = false"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col md="3">
          <v-pagination v-model="page" :length="paginationLength">
          </v-pagination>
        </v-col>
      </v-row>
      <loader v-if="isLoading"></loader>
      <v-row v-else>
        <v-col md="12">
          <v-card elevation="6">
            <v-simple-table fixed-header>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" style="min-width: 56px">Sr No</th>
                    <th class="text-left" style="min-width: 85px">Epaper ID</th>
                    <th class="text-left" style="min-width: 85px">Category</th>
                    <th class="text-left" style="min-width: 105px">
                      Edition Name
                    </th>
                    <th class="text-left" style="min-width: 135px">
                      Story Date
                    </th>
                    <th class="text-left" style="min-width: 150px">Headline</th>
                    <th class="text-left" style="min-width: 65px">
                      Word Count
                    </th>
                    <th class="text-left" style="min-width: 65px">Used In</th>
                    <th class="text-left" style="min-width: 70px">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(etArticle, i) in et_articles"
                    :key="etArticle.name"
                  >
                    <td>{{ serialNoStarting + i + 1 }}</td>
                    <td>{{ etArticle.id }}</td>
                    <td>{{ etArticle.category }}</td>
                    <td>{{ etArticle.edition_name }}</td>
                    <td>{{ etArticle.story_date | MMddyyyy }}</td>
                    <td>{{ etArticle.headline }}</td>
                    <td>{{ etArticle.word_count }}</td>
                    <td>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            dark
                            color="primary"
                            size="25"
                            v-bind="attrs"
                            v-on="on"
                            icon
                            v-if="etArticle.contents.length"
                            @click="ShowDetails(etArticle.id)"
                          >
                            <v-icon> mdi-check-all </v-icon>
                          </v-btn>
                        </template>
                        <span> View Contents </span>
                      </v-tooltip>
                    </td>
                    <td style="width: 150px">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            target="_blank"
                            size="25"
                            v-bind="attrs"
                            v-on="on"
                            icon
                            color="primary"
                            :to="`/epaper/et/${etArticle.id}`"
                          >
                            <v-icon> mdi-eye-outline </v-icon>
                          </v-btn>
                        </template>
                        <span> View Epaper </span>
                      </v-tooltip>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            target="_blank"
                            size="25"
                            v-bind="attrs"
                            v-on="on"
                            icon
                            color="primary"
                            :to="`/contents/create?etEpaperId=${etArticle.id}`"
                          >
                            <v-icon dark> mdi-plus </v-icon>
                          </v-btn>
                        </template>
                        <span> Create Content </span>
                      </v-tooltip>
                      <epaper-bookmark-dialog
                        :epaper="etArticle"
                        :epaper_type="'ET'"
                      ></epaper-bookmark-dialog>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>
        </v-col>
      </v-row>
      <v-dialog
        v-model="show_contents"
        transition="dialog-bottom-transition"
        max-width="1000"
      >
        <v-card elevation="2" class="rounded-tl-xl rounded-br-xl">
          <v-card-title class="justify-center primary accent-1 white--text">
            Contents linked to Epaper Id :{{ article_details.id }}
          </v-card-title>
          <v-card-text class="mt-5">
            <v-simple-table fixed-header>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Sr No</th>
                    <th class="text-left">ID</th>
                    <th class="text-left">Type</th>
                    <th class="text-left">Title</th>
                    <th class="text-left">Reading Time</th>
                    <th class="text-left">Written By</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(content, i) in article_details.contents"
                    :key="content.name"
                  >
                    <td>{{ i + 1 }}</td>
                    <td class="pa-1">{{ content.id }}</td>
                    <td class="pa-1">{{ content.content_type }}</td>
                    <td class="pa-1">{{ content.content_name }}</td>
                    <td>{{ content.reading_time }} mins</td>
                    <td>
                      {{ content.written_by_name }}
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
import EpaperBookmarkDialog from "@/components/EpaperBookmarkDialog.vue";
import Loader from "@/components/loader.vue";
export default {
  components: { EpaperBookmarkDialog, Loader },
  name: "etArticlesPage",
  data() {
    return {
      page: 1,
      serialNoStarting: 1,
      paginationLength: 0,
      count: 0,
      search_keyword: "",
      word_count: "",
      date_menu: "",
      et_articles: [],
      article_details: [],
      show_contents: false,

      isLoading: false,
      wordCounts: [
        { id: "100", value: "100", text: "More than 100" },
        { id: "250", value: "250", text: "More than 250" },
        { id: "350", value: "350", text: "More than 350" },
        { id: "500", value: "500", text: "More than 500" },
      ],
      date_filter: "",
    };
  },
  watch: {
    page: "getData",
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      this.isLoading = true;
      this.search_keyword = this.search_keyword ? this.search_keyword : "";
      let et_articles = [];
      let query =
        "page=" +
        this.page +
        "&rowsPerPage=" +
        this.rowsPerPage +
        "&search_keyword=" +
        this.search_keyword +
        "&word_count=" +
        this.word_count +
        "&date_filter=" +
        this.date_filter;
      et_articles = await axios.get(`et_articles?${query}`);
      this.et_articles = et_articles.data.data;
      this.count = et_articles.data.count;
      this.serialNoStarting = (this.page - 1) * this.rowsPerPage;
      this.paginationLength = Math.ceil(this.count / this.rowsPerPage);
      this.isLoading = false;
    },
    async ShowDetails(id) {
      this.article_details = [];
      this.article_details = this.et_articles.filter((et) => et.id == id)[0];
      if (this.article_details) {
        this.show_contents = true;
      }
    },
  },
};
</script>
